//* run "npx webpack serve --https --env mode=development --progress --no-live-reload"

import { GoogleMapLoader } from "./map/GoogleMapLoader";
import { Map } from "./map/Map";
import { FormMap } from "./map/FormMap";
import { initializeRouteHelp } from "./map/RouteHelp";
import { initializeRiskReportsModal } from "./map/RiskAssessment/RiskReportsModal";

// Load Styles
import "../scss/main.scss";

// eslint-disable-next-line no-undef
require("bootstrap-icons/font/bootstrap-icons.css");

document.addEventListener("DOMContentLoaded", function () {
  initializeRouteHelp();
  initializeRiskReportsModal();
  initializeMap();
});

function initializeMap() {
  GoogleMapLoader.loadGoogleMapsApi()
    .then(function (googleMaps) {
      let mapHtmlElement = document.getElementById("map");
      if (mapHtmlElement) {
        new Map(googleMaps, mapHtmlElement).create();
        return;
      }
      mapHtmlElement = document.getElementById("form-map");
      if (mapHtmlElement) {
        new FormMap(googleMaps, mapHtmlElement).create();
      }
    });
}
